import * as THREE from "three";
import { gui } from "./debug";

const debugObject = {
  ambientLight: {
    color: "#c9c2c0",
  },
  directionalLight: {
    color: "#fff9f5",
    lookAt: {
      y: 0,
    },
  },
  directionalFillLight: {
    color: "#f5f0ff",
  },
};

/**
 * Lights
 */

const lightsTweaks = gui.addFolder("Lights");

// Ambient light
const ambientLight = new THREE.AmbientLight(
  new THREE.Color(debugObject.ambientLight.color),
  2.4
);
lightsTweaks
  .add(ambientLight, "intensity")
  .min(0)
  .max(10)
  .step(0.001)
  .name("Ambient light intensity");
lightsTweaks
  .addColor(debugObject.ambientLight, "color")
  .onChange(() => {
    ambientLight.color = new THREE.Color(debugObject.ambientLight.color);
  })
  .name("Ambient light color");

// Directional light
const directionalLight = new THREE.DirectionalLight(
  new THREE.Color(debugObject.directionalLight.color),
  2.8
);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.width = 2000;
directionalLight.shadow.mapSize.height = 2000;
directionalLight.shadow.camera.near = 1;
directionalLight.shadow.camera.far = 5;
directionalLight.shadow.camera.top = 2;
directionalLight.shadow.camera.right = 2;
directionalLight.shadow.camera.bottom = -2;
directionalLight.shadow.camera.left = -2;
directionalLight.shadow.radius = 150;
directionalLight.shadow.blurSamples = 15;
directionalLight.position.set(2.2, 1.4, 0.3);

lightsTweaks
  .add(directionalLight, "intensity")
  .min(0)
  .max(10)
  .step(0.001)
  .name("Directional light intensity");
lightsTweaks
  .add(directionalLight.position, "x")
  .min(-5)
  .max(5)
  .step(0.001)
  .name("Directional light position x");
lightsTweaks
  .add(directionalLight.position, "y")
  .min(-5)
  .max(5)
  .step(0.001)
  .name("Directional light position y");
lightsTweaks
  .add(directionalLight.position, "z")
  .min(-5)
  .max(5)
  .step(0.001)
  .name("Directional light position z");
lightsTweaks
  .add(directionalLight.shadow, "radius")
  .min(-5)
  .max(45)
  .step(0.5)
  .name("Directional light shadow radius");
lightsTweaks
  .add(directionalLight.shadow, "blurSamples")
  .min(0)
  .max(45)
  .step(0.5)
  .name("Directional light blurSamples");
lightsTweaks
  .addColor(debugObject.directionalLight, "color")
  .onChange(() => {
    directionalLight.color = new THREE.Color(
      debugObject.directionalLight.color
    );
  })
  .name("Directional light color");

lightsTweaks.hide();

const directionalLightCameraHelper = new THREE.CameraHelper(
  directionalLight.shadow.camera
);
directionalLightCameraHelper.visible = false;

const directionalFillLight = new THREE.DirectionalLight(
  new THREE.Color(debugObject.directionalFillLight.color),
  0.9
);
directionalFillLight.castShadow = true;
directionalFillLight.shadow.mapSize.width = 2000;
directionalFillLight.shadow.mapSize.height = 2000;
directionalFillLight.shadow.camera.near = 1;
directionalFillLight.shadow.camera.far = 5;
directionalFillLight.shadow.camera.top = 2;
directionalFillLight.shadow.camera.right = 2;
directionalFillLight.shadow.camera.bottom = -2;
directionalFillLight.shadow.camera.left = -2;
directionalFillLight.shadow.radius = 5;
directionalFillLight.position.set(-0.6, 0.8, 0.2);

const directionalFillLightCameraHelper = new THREE.CameraHelper(
  directionalFillLight.shadow.camera
);
directionalFillLightCameraHelper.visible = false;

lightsTweaks
  .add(directionalFillLight, "intensity")
  .min(0)
  .max(10)
  .step(0.001)
  .name("Directional fill light intensity");
lightsTweaks
  .add(directionalFillLight.position, "x")
  .min(-5)
  .max(5)
  .step(0.001)
  .name("Directional fill light position x");
lightsTweaks
  .add(directionalFillLight.position, "y")
  .min(-5)
  .max(5)
  .step(0.001)
  .name("Directional fill light position y");
lightsTweaks
  .add(directionalFillLight.position, "z")
  .min(-5)
  .max(5)
  .step(0.001)
  .name("Directional fill light position z");
lightsTweaks
  .add(directionalFillLight.shadow, "radius")
  .min(-5)
  .max(45)
  .step(0.5)
  .name("Directional fill light shadow radius");
lightsTweaks
  .addColor(debugObject.directionalFillLight, "color")
  .onChange(() => {
    directionalFillLight.color = new THREE.Color(
      debugObject.directionalFillLight.color
    );
  })
  .name("Directional fill light color");

export {
  ambientLight,
  directionalLight,
  directionalFillLight,
  directionalFillLightCameraHelper,
  directionalLightCameraHelper,
};
